import * as Constants from '../Constants';

const getEnvironmentName = () => {
  let env = '';
  switch (window.location.hostname) {
    case Constants.LOCAL_HOST:
      env = Constants.LOCAL;
      break;
    case Constants.ITG_HOST:
      env = Constants.ITG;
      break;
    case Constants.INTERNAL_CAT_HOST:
      env = Constants.CAT_INTERNAL;
      break;
    case Constants.EXTERNAL_CAT_HOST:
      env = Constants.CAT_EXTERNAL;
      break;
    case Constants.INTERNAL_PROD_HOST:
      env = Constants.PROD_INTERNAL;
      break;
    case Constants.EXTERNAL_PROD_HOST:
      env = Constants.PROD_EXTERNAL;
      break;
    case Constants.AWS_DEV_HOST:
      env = Constants.AWS_DEV;
      break;
    case Constants.AWS_ITG_HOST:
      env = Constants.AWS_ITG;
      break;
    case Constants.AWS_CAT_HOST:
      env = Constants.AWS_CAT;
      break;
    case Constants.AWS_PROD_HOST:
      env = Constants.AWS_PROD;
      break;
    case Constants.DEV_SPOKE_HOST:
    case Constants.DEV_SPOKE_VANITY_HOST:
      env = Constants.AWS_DEV_SPOKE;
      break;
    case Constants.ITG_SPOKE_HOST:
    case Constants.ITG_SPOKE_VANITY_HOST:
      env = Constants.AWS_ITG_SPOKE;
      break;
    case Constants.CAT_SPOKE_HOST:
    case Constants.CAT_SPOKE_VANITY_HOST:
      env = Constants.AWS_CAT_SPOKE;
      break;
    case Constants.PROD_SPOKE_HOST:
      env = Constants.AWS_PROD_SPOKE;
      break;
    default:
      throw new Error(`Invalid host found: ${window.location.hostname}`);
  }
  return env;
};

export default getEnvironmentName;
